// extracted by mini-css-extract-plugin
module.exports = {"block_padding":"12px","list":"list-29cfZ","item":"item-2FI2n","item_FNN":"item_FNN-3KykZ"};